import moment from "moment";
import i18nLocale from "@/helpers/locale";

export function generateTimeStamp(form) {
  let { hour, minute } = form;
  hour = !hour ? 0 : hour;
  minute = !minute ? 0 : minute;
  const timeString = `${moment(form.date).format("YYYY/MM/DD")} ${parseInt(hour) < 10 ? "0" + hour : hour}:${parseInt(minute) < 10 ? "0" + minute : minute}`;
  // return this.$moment(this.transCreateForm.date).format("YYYY/MM/DD");
  return moment(timeString).valueOf();
}

export function generateTimeString(form) {
  return moment(form.date).format("YYYY-MM");
}

export function hourMinuteLimit_fn(form, value, key) {
  form[key] = value.replace(/^\.+|[^\d.]/g, "");
  if (value && !isNaN(value)) {
    if (key === "hour") {
      if (parseInt(value) > 23) {
        form.hour = "23";
      }
    } else if(key === "minute") {
      if (parseInt(value) > 59) {
        form.minute = "59";
      }
    }
  }
}

export function deleteConfirm_fn(data) {
  let confirmHtml =
        "<i class=\"egl-confirm-question\">?</i><span class=\"result-text\">" +
        i18nLocale(data.searchId) + i18nLocale("version.screen.action.del") +
        "</span>";
}